import { IndicatorSelection, LayerProperties } from "../../types";
import { useSelectedLayer } from "hooks/selectionHooks";
import { useLegend } from "hooks/legendHooks";
import { useIndicator } from "hooks/indicatorHooks";
import { LegendItem } from "./LegendItem";

interface Props {
  config: string;
  layerProperties: LayerProperties[];
  selection: IndicatorSelection;
}

export function LegendData(props: Props) {
  const { config, selection, layerProperties } = props;
  const { data: indicator } = useIndicator(
    config,
    selection.indicatorId,
    layerProperties
  );
  const { data: layer } = useSelectedLayer(config, indicator, layerProperties);
  const { data: legendData } = useLegend(layer);

  return (
    <>
      {legendData &&
        legendData.map((definition, i) => (
          <LegendItem
            definition={definition}
            key={`legend-data-${i}-${layer?.id || -1}`}
          />
        ))}
    </>
  );
}
